import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "DESDE 1998",
    text: "Quase três décadas marcando a pele e a história de Jundiaí. A Diggy Shop nasceu antes da tatuagem virar tendência — e segue definindo padrão.",
  },
  {
    num: "02",
    title: "BIOSSEGURANÇA TOTAL",
    text: "Materiais descartáveis, esterilização hospitalar e joias certificadas. Aqui, arte e responsabilidade caminham juntas, sem exceção.",
  },
  {
    num: "03",
    title: "ARTE AUTORAL",
    text: "Nada de catálogo genérico. Cada tattoo e cada furo são projetos únicos, desenhados para a sua identidade e para o seu corpo.",
  },
];

export const Manifesto = () => (
  <section id="manifesto" className="bg-[#F3F3F3] text-[#0A0A0A] py-24 lg:py-32 px-6" data-testid="manifesto-section">
    <div className="max-w-7xl mx-auto">
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="text-xs tracking-[0.3em] font-bold text-[#E60000] mb-4"
      >
        MANIFESTO DIGGY
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="font-display font-bold text-4xl md:text-5xl leading-none max-w-2xl mb-20"
      >
        Uma marca consolidada, <span className="italic text-[#E60000]">não um estúdio qualquer.</span>
      </motion.h2>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16">
        {CHAPTERS.map((c, i) => (
          <motion.article
            key={c.num}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
            className={`border-t-2 border-[#0A0A0A] pt-8 ${i === 1 ? "md:mt-16" : ""} ${i === 2 ? "md:mt-32" : ""}`}
            data-testid={`manifesto-chapter-${c.num}`}
          >
            <span className="font-display font-black text-5xl text-[#E60000]">{c.num}.</span>
            <h3 className="mt-6 text-xl font-extrabold tracking-tight">{c.title}</h3>
            <p className="mt-4 text-base font-light leading-relaxed text-[#0A0A0A]/70">{c.text}</p>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
